import { actionCreator } from '../../../helpers/utils';

export const SHOW_TOAST = 'SHOW_TOAST';
export const HIDE_TOAST = 'HIDE_TOAST';

const showToast = ({ variant = 'success', messageId = '', values = {}, autoCloseMs = 6000 }) =>
    actionCreator(SHOW_TOAST, {
        id: `${Date.now()}_${Math.random()}`,
        variant,
        messageId,
        values,
        autoCloseMs
    });

const hideToast = id => actionCreator(HIDE_TOAST, { id });

export default {
    showToast,
    hideToast
};



// WEBPACK FOOTER //
// ./containers/console/actions/toast-actions.js